// extracted by mini-css-extract-plugin
export default {"searchInput":"input_searchInput__NNrUB","selectInput":"input_selectInput__Hq51U"};